
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
components: { XDialog },
directives: { TransferDom },
props: {
show: {
type: Boolean,
default: false
},
hideOnBlur: {
type: Boolean,
default: true
},
maskZIndex: {
type: Number,
default: 1000
},
showClose: {
type: Boolean,
default: true
},
dialogStyle: {
type: Object,
default: () => {
return {}
}
}
},
data() {
return {
dStyle: {'max-width': '100%', width: '100%', height: '100%', 'background-color': 'transparent' },
open: false
}
},
watch: {
show(v) {
this.open = v
}
},
created() {
this.open = this.show
this.dStyle = Object.assign({}, this.dStyle, { 'z-index': this.maskZIndex + 1 },  this.dialogStyle)
},
methods: {
onShow() {
this.$emit('onShow', true)
},
onHide() {
this.$emit('onHide', true)
}
}
}



// WEBPACK FOOTER //
// ./src/common/components/g-dialog/index.vue